import { _ } from "libs";
import React, { FC, useState } from "react";
import { Club, Connected } from "../../types";
import cx from "classnames";
import { favoriteClub, unfavoriteClub } from "../../actions";

interface Props {
	club: Club;
	favoriteClub: Connected<typeof favoriteClub>;
	unfavoriteClub: Connected<typeof unfavoriteClub>;
}

const FavoriteStar: FC<Props> = ({ club, favoriteClub, unfavoriteClub }: Props) => {
	const [isFavorite, setFavorite] = useState(club.clubDetails.isFavorite);

	const onClick = () => {
		if (isFavorite) {
			unfavoriteClub(club);
		} else {
			favoriteClub(club);
		}

		setFavorite(!isFavorite);
	};

	const className = cx({ favorite: isFavorite, markAsFavorite: !isFavorite });
	return (
		<div
			className={className}
			title={isFavorite ? _("club.removeFromFavorites") : _("club.addToFavorites")}
			onClick={onClick}
		/>
	);
};

export default FavoriteStar;
